import { FontColorPlugin } from '@platejs/basic-styles/react';
import { KEYS } from 'platejs';

import TextColorIcon from '../../../../../icons/text-color.svg?react';
import { ColorPopoverControl } from './shared';

export const textColorPlugin = FontColorPlugin.configure({
  inject: {
    nodeProps: {
      defaultNodeValue: 'black',
    },
    targetPlugins: [KEYS.p],
  },
});

const TEXT_COLOR_MARK = textColorPlugin.key;

export const TextColorToolbarControl = ({
  label = 'Text color',
  clearLabel = 'Clear text color',
}: {
  label?: string;
  clearLabel?: string;
}) => {
  return (
    <ColorPopoverControl
      clearLabel={clearLabel}
      icon={TextColorIcon}
      label={label}
      markKey={TEXT_COLOR_MARK}
    />
  );
};
